import List from "@mui/material/List";

interface ListPrimaryContentProps {
  children?: React.ReactNode;
}

function ListPrimaryContent(props: ListPrimaryContentProps) {
  const { children } = props;

  return (
    <List data-sidebar="group" sx={{ display: "flex", flexDirection: "column", padding: "0 8px" }}>
      {children}
    </List>
  );
}

export default ListPrimaryContent;
